<template>
  <div class="comment-show">
    <div v-if="info.state" class="comment-info">
      <div class="student-item"> 
        <div class="student-img">
          <img :src="defalutPicUrl"/>
        </div>
        <div class="student-name"> {{ info.name }} 收到的课后点评</div>
      </div>
      <div class="info-box">
        <div class="teacher-info">
          <div class="teacher-img">
           <img :src="info.teacherPic ? info.teacherPic : defalutPicUrl"/>
          </div>
          <div class="name-time">
            <div class="name"> 来自 {{ info.teacher }} 的评价 </div>
          </div>
        </div>
        <div class="praise-satar-component" v-if="info.lessonItemList.length">
          <div v-for="(item, index) in info.lessonItemList" :key="index" class="praise-start-item" :class="{ borderBottomNone :index+1 === info.lessonItemList.length }">
            <div class="praise-start-name"> {{ item.name }} </div>
            <div class="praise-start-target">
              <div v-for="(item_min, index_min) in 5" :key="index_min" class="start-icon">
                <img v-if="index_min+1 <= item.startsCount" src="@assets/images/bright-start.png"/>
                <img v-else src="@assets/images/extinct-start.png"/>
              </div>
            </div>
          </div>
        </div>
        <div class="comment-text">{{ info.commentText }}</div>
        <div class="pic-show-box">
          <div v-for="(item, index) in info.picUrlList" :key="index" class="pic-url-box">
            <div v-if="item.url && item.type !== 0" class="pic-url" :class="{ noImgPic: item.type !== 1}">
              <img v-if="item.type === 1" :src="item.url"/>
              <video v-if="item.type === 3" :src="item.url" controls/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import { commentWorksInfoVisit } from '@api/grade'
  import { getFlieType, addZoo } from '@common'

  export default {
    name: 'CommentShow',
    data() {
      return {
        defalutPicUrl: require('@assets/images/1.jpg'),
        info: {}
      }
    },
    methods: {
      fileType(url) { //检测文件类型
        let type = getFlieType(url);
          if (type === 'image') { //图片
            return 1;
          }else if (type === 'radio') { //音乐
            return 2;
          }else if (type === 'video') { //视频
            return 3;
          }else {
            return 0;
          }
      },
      /**
       * get data
       */
      getCommentInfoDesc(params) {
        let form = {
          content_id: params.contentId
        }
        commentWorksInfoVisit(form).then(this.setInfoData);
      },
      setInfoData(res) {
          let result = res.data.information[0];
          let infoStore = {
            name: result.name,
            teacher: result.staff_name,
            // time: '昨天20:12',
            teacherPic: result.staff_name_avatar,
            commentText: result.contentname,
            currentTime: `${new Date(Number(result.datatime+'000')).getFullYear()}-${addZoo(new Date(Number(result.datatime+'000')).getMonth()+1)}-${addZoo(new Date(Number (result.datatime+'000')).getDate())}`,
            startTime: result.start_time,
            stopTime: result.stop_time,
            lessonName: result.lesson,
            state: true,
          }
          let picUrlList = [];
          if (result.video_images.length && Array.isArray(result.video_images)) {
            picUrlList = result.video_images.map(item => {
              return {
                url: item,
                type: this.fileType(item)
              }
            })
          }
          infoStore.picUrlList = picUrlList;
          let startList = [];
          if (result.template.length && Array.isArray(result.template)) {
            startList = result.template.map(item => {
              return {
                name: item.template,
                startsCount: item.starlevel
              }
            })
          }
          infoStore.lessonItemList = startList;
          this.info = infoStore;
        }
    },
    mounted() {
      let params = this.$route.query;
      this.getCommentInfoDesc(params);
    }
  }
</script>

<style scoped>
.comment-show {
  height: 100vh;
  width: 100vw;
  background-color: #8fb8f2;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  font-size: 0.32rem;

}
.comment-info {
  padding-bottom: 1rem;
}
  .student-item {
    padding: 0.2rem;
    display: flex;
    border-top: 0.02rem solid #f3f3f3;
    align-items: center;
    font-size: 0.34rem;
    font-weight: 600;
    color: white;
  }
    .student-img, .teacher-img {
      width: 1rem;
      height: 1rem;
      overflow: hidden;
      border-radius: 50%;
      margin-right: 0.3rem;
    }
      .student-img img, .teacher-img img {
        width: 100%;
        height: 100%;
      }
    .student-name {
      display: flex;
      flex: 1;
      align-items: center;
    }
      .arrive {
        font-size: 0.26rem;
        display: flex;
        align-items: center;
        margin-left: 0.2rem;
        border: 0.02rem solid #b5b3b3;
        color: #8c8c8c;
        height: 0.36rem;
        padding: 0 0.1rem;
        border-radius: 0.04rem;
      }
  .info-box {
    background-color: white;
    padding: 0.2rem 0;
    border-radius: 0.2rem;
  }
      .name-time {
        display: flex;
        align-items: center;
        color: #a6a6a6;
      }
  .lesson-info {
    padding: 0 0.2rem;
    color: #9f9ea0;
    font-size: 0.28rem;
  }
  .title-text {
    padding: 0.2rem;
    font-size: 0.34rem;
  }
  .teacher-info {
    display: flex;
    padding: 0 0.2rem;
  }
      .time {
        margin-top: 0.06rem;
        font-size: 0.28rem;
        color: #b2b0b5;    
      }
  .praise-satar-component {
    background-color: white;
    font-size: 0.3rem;
  }
    .praise-start-item {
      padding: 0.2rem;
      border-bottom: 0.02rem solid #faf5fb;
      display: flex;
      justify-content: space-between;
    }
      .praise-start-name {
        display: flex;
        align-items: center;
      }
      .praise-start-target {
        display: flex;
      }
        .start-icon {
          margin: 0 0.04rem;
        }
          .start-icon img {
            width: 0.4rem;
            height: 0.4rem;
          }
    .borderBottomNone {
      border-bottom: none;
    }
  .comment-text {
    padding:0 0.2rem 0.2rem;
  }
  .pic-show-box {
    display: flex;
    flex-wrap: wrap;
    padding: 0.3rem;
  }
    .pic-url-box {
      width: 100%;
    }
      .pic-url {
        width: 100%;
        padding: 0.2rem;
        border: 0.2rem solid #8fb8f2;
        border-radius: 0.2rem;
        box-shadow: 0.06rem 0.06rem 0.12rem #767676, 0.06rem 0.06rem 0.12rem #a7a5a5 inset;
        margin-bottom: 0.2rem;
      }
      .noImgPic {
        width: 100%;
        /* height: 4rem; */
      }
        .pic-url img, .pic-url video {
          width: 100%;
        }
</style>